export const WIDTH_AND_HEIGHT_BLOCK = 12;

export const TARGET_PROP = "table";
